import { createContentPropTypes } from '../../../helpers/content';

const content = {
	AuthorisationTitle: 'Authorisation required',
	AuthorisationSubTitle: 'This will need authorised once you continue.',
	PaymentAuthorisation: 'This will need authorised once you continue',
	PaymentAuthorisationByNamed: 'This will need authorised by',
	PageHeader: 'Review',
	PageSubHeader: 'Please confirm the details you’ve entered are correct before you continue.',
	pageSubHeaderMsg:
		'Remember that CHAPS payments must be set up and authorised by 5pm to guarantee they’ll arrive on the same day.',
	AuthorisationHeader: 'Authorisation required',
	AuthorisationBodyMsg:
		'Once you’ve confirmed the details are correct and you choose to continue, any transactions that are highlighted will have to be authorised using one of our online security methods.',
	AuthorisationByUserSubTitle: 'This will need authorised by ',
	fromLabel: 'From',
	toLabel: 'To',
	amtLabel: 'Amount',
	refLabel: 'Reference',
	dateLabel: 'Date',
	typeLabel: 'Type',
	feesLabel: 'Fees',
	continueButtonText: 'Confirm and submit',
	deadlineMissedTitle: 'CHAPS deadline missed',
	deadlineMissedBody: 'As this payment’s being submitted after 5pm, it’ll now be sent on the following date:',
	deadlineMissedAcceptButton: 'Accept and submit payment',
	deadlineMissedGoBackButton: 'Go back',
	deadlineMissedCancelButton: 'Cancel payment',
	deadlineMissedSubmissionDateLabel: 'Payment date:',
	deadlineMissedConfirmCancel: 'Yes, cancel payment',
	deadlineMissedBackoutOfCancel: 'No, go back',
	BatchAuthorisationBodyMsg: 'This will need authorised by ',
	changeAuthoriserButton: 'Change',
	selectAuthoriserButton: 'Select user to authorise',
	viewAuthoriserButton: 'View users who can authorise',
};

const traObligateContent = {
	...content,
	AuthorisationHeader: 'Authorisation may be required',
	AuthorisationBodyMsg:
		'Once you’ve confirmed the details are correct and you choose to continue, any transactions that are highlighted may have to be authorised using one of our online security methods.',
	AuthorisationByUserSubTitle: 'This may need authorised by',
};

export const contentPropTypes = createContentPropTypes(content);

export default { content, traObligateContent };
